import BaseProxy from './BaseProxy';

class Course extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/courses', parameters);
    }

    async getCourseMap(id) {
        return this.submit('get', `/${id}/map`);
    }
}

export default Course;



// WEBPACK FOOTER //
// ./src/api/Course.js